'use client'

import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '@mui/material/Button'
import type { FC } from 'react'
import { useAnalytics } from '../../context/Analytics'

interface RespondToMailOfferProps {
  id?: string
}

const RespondToMailOffer: FC<RespondToMailOfferProps> = ({
  id = 'respond-to-mail-offer-button',
}) => {
  const { track, events } = useAnalytics()
  return (
    <Button
      id={id}
      data-testid={id}
      variant="text"
      className="respond-to-mail-offer w-full text-nowrap md:w-fit"
      startIcon={<FontAwesomeIcon icon={faEnvelope} />}
      href={`${process.env.NEXT_PUBLIC_CAFE_ORIGIN}/card/mail`}
      onClick={() => track?.(events.INTERACTION.ClickCta, { cta: 'Respond to a Mail Offer' })}
    >
      Respond to a Mail Offer
    </Button>
  )
}

export default RespondToMailOffer
